const resolveLink = ( path ) => {
    path = path === 'home' ? '/' : path
    return `${path.startsWith('/') ? "" : "/"}${path.replace(/\/$|$/, `/`)}`
}
export default resolveLink